module.exports = __webpack_public_path__ + "static/20240528_Announcement_Mgmt-ac2fda350d8285c7aa21b1b04e9480c4.pdf";